export const PLANNING_DEFAULT_DISPLAY = Object.freeze({
    showUrgentes: true,
    showAujourdhui: true,
    showRetard: false,
    showProgression: false,
    showTopTaches: true,
    showStatuts: true,
    viewMode: 'kanban',
    // Différencie le défaut produit des choix de vue faits volontairement.
    viewModeConfigured: false,
});

export const RSP_DEFAULT_DISPLAY = Object.freeze({
    showKpis: true,
    showRecentProblems: true,
    showOpenCta: true,
});

export const readDisplayPreferences = (storageKey, defaults, storage = window.localStorage) => {
    try {
        const saved = JSON.parse(storage.getItem(storageKey) || '{}');
        return saved && typeof saved === 'object' && !Array.isArray(saved)
            ? {...defaults, ...saved}
            : {...defaults};
    } catch (_) {
        return {...defaults};
    }
};

export const saveDisplayPreferences = (storageKey, preferences, storage = window.localStorage) => {
    storage.setItem(storageKey, JSON.stringify(preferences));
    return preferences;
};

/**
 * Les préférences initiales ne distinguaient pas une ancienne vue liste d’un
 * choix volontaire. Elles basculent donc une fois vers le Kanban par défaut.
 * Tout choix postérieur conserve explicitement son intention.
 */
export const normalizePlanningDisplayPreferences = (preferences = {}) => {
    const normalized = {...PLANNING_DEFAULT_DISPLAY, ...preferences};
    const hasExplicitViewMode = preferences.viewModeConfigured === true;

    return {
        ...normalized,
        viewMode: hasExplicitViewMode && preferences.viewMode === 'list' ? 'list' : 'kanban',
        viewModeConfigured: hasExplicitViewMode,
    };
};
